
<div class="find-info-trending-pages" *ngIf="trendingPages$ | async as result; else loading">

    <hr class="mt-5 mb-5 d-block d-lg-none" />

    <div class="float-left"><i class="fa fa-fire accent-2-color"></i></div>

    <div class="ml-4 mt-lg-5">
        <h5 class="h6 text-color font-italic" i18n="find information trending pages title@@find-information-trending-pages-title">Trending</h5>
        <ul>
            <li *ngFor="let page of result" class="">
                <a class="link-text-color" href="{{page.Path}}">
                    {{page.Title}}
                </a>
            </li>
        </ul>
    </div>

</div>



<ng-template #loading>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
